import * as React from 'react';
import { formatDate, truncateCurrencyNumber } from '../utils';
import { ActionRequest } from '../actions';
import { connect } from 'react-redux';
import { BaseElement, BasePlayerContainer, Table } from '../components';
import { ContainerContext, mapProps } from './index';
import { useNavigate, useParams } from 'react-router';
import { StateMap } from '../reducers';
import { QueryResult } from 'material-table';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Android, PhoneIphone, Web } from '@mui/icons-material';

interface Props extends ContainerContext.Props {
    readonly playerId: string;
}

class Container extends BaseElement<Props> {
    protected renderContainer(): React.JSX.Element {
        const { playerId } = this.props;

        return (
            <BasePlayerContainer
                {...this.props}
                styled={this.props.styled}
                title = {"Payments"}
                playerId = {playerId}
                showSubTabs = {true}
            >
                {this.renderContent()}
            </BasePlayerContainer>
        );
    }

    private renderContent = () => {
        const columns = [
            { title: 'Platform', field: 'platform', render: (rowData: any) => rowData.platform === 1 ? <Android style={{ height: 20, width: 20, color: '#a4c639' }}/>
                    : rowData.platform === 2 ? <PhoneIphone style={{ height: 20, width: 20, color: '#326ef6' }} />
                        : <Web style={{ height: 20, width: 20 }}/>},
            { title: 'Transaction ID', field: 'transactionId'},
            { title: 'Product Id', field: 'productId'},
            { title: 'Quantity', field: 'quantity'},
            { title: 'Purchase Date', field: 'purchaseDate'},
            { title: 'Environment', field: 'environment'},
            { title: 'Price', field: 'price'},
        ];

        return (
            <Table
                styled={this.props.styled}
                columns={columns}
                data={this.getData}
                options={{
                    showTitle: false,
                    selection: false,
                    paging: true,
                    pageSize: 10,
                    pageSizeOptions: [5, 10, 30, 50, 100],
                    emptyRowsWhenPaging: false,
                    search: true,
                    sorting: false,
                    draggable: false,
                }}
            />
        );
    };

    private getData = async (query: any): Promise<QueryResult<any>> => {
        const { playerId } = this.props;
        if (!playerId) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
        const { search, page, pageSize, orderBy, orderDirection } = query;
        const params = {
            search,
            page: page + 1,
            perPage: pageSize,
            orderBy: orderBy ? orderBy.field : null,
            orderDirection: orderDirection !== "" ? orderDirection : null,
        };
        const result = await ActionRequest.get(`player/${playerId}/payments`, params);
        if (!result) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
        const data = result.entities.map((e: Entities.Payment) => {
            return {
                entity: e,
                transactionId: e.transactionId,
                productId: e.productId,
                quantity: e.quantity,
                purchaseDate: formatDate(e.purchaseTime),
                environment: (e.environment === 1) ? 'Production' : 'Sandbox',
                price: truncateCurrencyNumber(e.purchasePrice / 100, e.currencyCode),
                platform: e.platform ,
            };
        });

        return {
            data,
            page: result.page - 1,
            totalCount: result.totalCount,
        };
    }
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
    playerId: '',
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    const params = useParams();
    const playerId = params.playerId || '';
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate} playerId={playerId}/>);
};
export default connect(mapStateToProps)(AppContainer);
